import { Directive, ElementRef, OnDestroy, OnInit, Renderer2 } from '@angular/core';

@Directive({ selector: '[appDragScroll]' })
export class DragScrollDirective implements OnInit, OnDestroy {
  private el: HTMLElement;
  private isDown = false;
  private startX = 0;
  private scrollLeft = 0;
  private moved = false;
  private unlisten: (() => void)[] = [];

  constructor(private elRef: ElementRef<HTMLElement>, private renderer: Renderer2) {
    this.el = elRef.nativeElement;
  }

  ngOnInit() {
    this.renderer.setStyle(this.el, 'cursor', 'grab');
    this.renderer.setStyle(this.el, 'user-select', 'none');

    this.unlisten.push(
      this.renderer.listen(this.el, 'mousedown', (e: MouseEvent) => this.onMouseDown(e)),
      this.renderer.listen('document', 'mousemove', (e: MouseEvent) => this.onMouseMove(e)),
      this.renderer.listen('document', 'mouseup', () => this.onMouseUp())
    );
  }

  ngOnDestroy() {
    this.unlisten.forEach(fn => fn());
  }

  private onMouseDown(e: MouseEvent) {
    if (e.button !== 0) return;
    this.isDown = true;
    this.moved = false;
    this.startX = e.clientX;
    this.scrollLeft = this.el.scrollLeft;
    this.renderer.setStyle(this.el, 'cursor', 'grabbing');
    this.renderer.setStyle(this.el, 'scroll-behavior', 'auto');
  }

  private onMouseMove(e: MouseEvent) {
    if (!this.isDown) return;
    e.preventDefault();
    const dx = e.clientX - this.startX;
    if (Math.abs(dx) > 3) this.moved = true;
    this.el.scrollLeft = this.scrollLeft - dx;
  }

  private onMouseUp() {
    if (!this.isDown) return;
    this.isDown = false;
    this.renderer.setStyle(this.el, 'cursor', 'grab');
    this.renderer.removeStyle(this.el, 'scroll-behavior');

    if (this.moved) {
      const blocker = (ev: Event) => { ev.stopPropagation(); ev.preventDefault(); };
      this.el.addEventListener('click', blocker, { capture: true, once: true });
    }
  }
}
